export const MAX_GRID_SIZE = 5;
export const MAX_USERS = MAX_GRID_SIZE * MAX_GRID_SIZE;
export const MAX_VISIBLE_USERS = MAX_USERS - 1;
